import axios from 'axios';
import { to } from 'await-to-js';

const {
    REACT_APP_API_URL
} = process.env;

export async function registrarUsuarioTienda(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/usuario/registrar`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function loginUsuarioTienda(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/usuario/login`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerCoordenadasUsuarioTienda(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/usuario/coordenadas`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}
